/**
 * Табличная форма для описателя объектов. Модуль для работы с API.
 * @module definitionTableForm
 */

/**
 *  Изменение поля табличной формы описателя
 * @param {object} item - данные поля
 * @param {string} item.uuid - идентификатор поля
 * @param {string} item.idx - порядковый номер (нумерация с 0)
 * @param {string} item.is_visible - флаг видимости поля
 * @returns {Promise} - обновленное поле
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateField = async (item) => {
  try {
    const response = await fetch("/api/definitiontableformfield", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.field;
  } catch (err) {
    throw err;
  }
};
